const getTreeState = (state, treeId) => state[treeId] || null;

export const treeIsInitialized = tree => state => !!getTreeState(state, tree);

export const getSelection = (tree, { selection }) => state => {
  const treeState = getTreeState(state, tree);

  if (!selection || !treeState) {
    return null;
  }

  return selection.getSelection(treeState);
};

export const treeSelectionVisuals = (tree, { selection }) => () =>
  (selection && selection.selectionVisuals) || null;

export const nodeChildrenIds = tree => (state, parentId) =>
  getTreeState(state, tree)?.children?.[parentId] || null;

export const nodeExpandedStatus = tree => (state, nodeId) => {
  if (nodeId === null) {
    return true;
  }

  const treeState = getTreeState(state, tree);

  if (
    treeState &&
    treeState.expandedNodeIds &&
    treeState.expandedNodeIds[nodeId] === false
  ) {
    return false;
  }

  return (
    (treeState &&
      treeState.expandedNodeIds &&
      treeState.expandedNodeIds[nodeId]) ||
    true
  );
};

export const isTreeRootLoading = (tree, { lazyLoading }) => state => {
  const treeState = getTreeState(state, tree);

  if (treeState && lazyLoading) {
    return lazyLoading.isLoading(treeState, null);
  }

  return false;
};

export const treeSelection = (tree, { selection }) => state => {
  const treeState = getTreeState(state, tree);

  if (treeState && selection) {
    return selection.getSelection(treeState);
  }

  return null;
};

export const treeInputModels = tree => state => {
  const treeState = getTreeState(state, tree);
  return (treeState && treeState.inputModels) || null;
};

export const treeFilter = tree => state => {
  const treeState = getTreeState(state, tree);
  return (treeState && treeState.filter) || null;
};

export const treeContext = tree => state => {
  const treeState = getTreeState(state, tree);
  return (treeState && treeState.context) || null;
};

export const makeSubtreeSelector = (tree, searchTree) => state => leafs => {
  const treeState = searchTree
    ? getSearchTreeState(state, tree)
    : getTreeState(state, tree);
  if (!treeState) {
    return [];
  }

  const { models, parents } = treeState;

  const ids = new Set();
  for (const leaf of leafs) {
    add(leaf.id);
  }
  return Array.from(ids).map(id => models[id]);

  function add(id) {
    if (id) {
      ids.add(id);
      add(parents[id]);
    }
  }
};

export const hasSubtree = treeId => (state, leafId) => {
  const treeState = getTreeState(state, treeId);
  return !!treeState && !!treeState.models[leafId];
};

const getSearchTreeState = (state, treeId) => {
  let resultTree = treeId;
  Object.keys(state).some(searchTree => {
    if (searchTree.includes(`Search:${treeId}`)) {
      resultTree = searchTree;
      return true;
    }
  });
  return state[resultTree] || null;
};
